// --- Snowfall Effect Script (3-second burst) ---
document.addEventListener("DOMContentLoaded", function () {
    const path = window.location.pathname;
    const isChristmasCollection = path.startsWith("/collections/christmas-candy") && !path.includes("/products/");

    if (!isChristmasCollection) {
        return;
    }
  const snowContainer = document.createElement("div");
  document.body.appendChild(snowContainer);

  function createSnowflake() {
    const snowflake = document.createElement("div");
    snowflake.classList.add("snowflake");
    snowflake.textContent = "❄";
    snowflake.style.left = Math.random() * 250 + "vw";
    snowflake.style.animationDuration = 4 + Math.random() * 3 + "s"; // velocidad de caída
    snowflake.style.fontSize = 10 + Math.random() * 15 + "px"; // tamaño aleatorio
    snowflake.style.opacity = 0.5 + Math.random() * 0.5;
    snowContainer.appendChild(snowflake);
    setTimeout(() => snowflake.remove(), 7000); // desaparece después de 7 s
  }

  // Inicia la tormenta: crea copos cada 150 ms
  const snowInterval = setInterval(createSnowflake, 100);

  // Detiene la tormenta después de 3 segundos
  setTimeout(() => {
    clearInterval(snowInterval);
    console.log("❄️ Nieve detenida tras 3 segundos");
  }, 7000);
});

// --- Santa Sleigh Animation with Sine Path and Snow Trail ---
document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;
    
  const isChristmasCollection = path.startsWith("/collections/christmas-candy") && !path.includes("/products/");

    if (!isChristmasCollection) {
        return;
    }
  const santa = document.createElement("div");
  santa.classList.add("santa-sleigh");
  document.body.appendChild(santa);

  // Crea la estela luminosa
  const trail = document.createElement("div");
  trail.classList.add("santa-trail");
  santa.appendChild(trail);

  // --- Configura frames (trote) ---
  const frames = [
    "https://cdn.shopify.com/s/files/1/0706/5927/7049/files/santa-sleigh-2.svg?v=1762272214",
    "https://cdn.shopify.com/s/files/1/0706/5927/7049/files/santa-sleigh-1.svg?v=1762272214"
  ];
  let current = 0;
  const trot = setInterval(() => {
    santa.style.backgroundImage = `url(${frames[current]})`;
    current = (current + 1) % frames.length;
  }, 200);

  // --- Movimiento en onda seno ---
  let startTime = null;
  const duration = 10000; // 10 segundos de vuelo
  const amplitude = 40; // altura de la onda
  const frequency = 2; // cantidad de ondas (2 ciclos en todo el recorrido)

  function animateSanta(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = (timestamp - startTime) / duration;
    const x = progress * (window.innerWidth + 600) - 300; // movimiento horizontal
    const y = window.innerHeight * 0.3 + Math.sin(progress * Math.PI * frequency) * amplitude;

    santa.style.left = `${x}px`;
    santa.style.top = `${y}px`;

    // --- Copos de nieve acompañando ---
    if (Math.random() < 0.3) createSantaSnowflake(x, y);

    if (progress < 1) {
      requestAnimationFrame(animateSanta);
    } else {
      clearInterval(trot);
      santa.remove();
    }
  }

  // --- Copitos de nieve detrás del Santa ---
  function createSantaSnowflake(x, y) {
    const flake = document.createElement("div");
    flake.classList.add("santa-flake");
    flake.textContent = "❄";
    flake.style.left = x - 20 + Math.random() * 40 + "px";
    flake.style.top = y + Math.random() * 20 + "px";
    document.body.appendChild(flake);
    setTimeout(() => flake.remove(), 1500);
  }

  requestAnimationFrame(animateSanta);
});
